module.exports = __webpack_public_path__ + "b6d467aedc23c7e8e0b37e8f521655d0.MP3";